<template>
  <div class="navigator">
    <div class="wrap">
      <div class="logo-box">
        <img src="../../public/logo.png" alt="" />
        <span>辰时微光，心如沐阳</span>
      </div>
      <div class="router-box pc">
        <span
          tag="span"
          @click="to(item)"
          :class="{ active: item.path == $route.path }"
          v-for="(item, index) in $router.options.routes"
          :key="index"
          >{{ item.name }}</span
        >
      </div>
      <el-dropdown class="mobile" @command="command" trigger="click">
        <span class="el-dropdown-link">
          <i class="el-icon-s-operation"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="(item, index) in route"
            :key="index"
            :command="item.path"
            ><span
              class="menu-li"
              :class="{ active: item.path == $route.path }"
              >{{ item.name }}</span
            ></el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  props: {
    msg: String,
  },
  computed: {
    route() {
      return this.$router.options.routes.slice(
        0,
        this.$router.options.routes.length - 1
      );
    },
  },
  methods: {
    to(item) {
      this.$router.push({ path: item.path });
      if (item.path.indexOf("example") !== -1) {
        function launchFullscreen(element) {
          if (element.requestFullscreen) {
            element.requestFullscreen();
          } else if (element.mozRequestFullScreen) {
            element.mozRequestFullScreen();
          } else if (element.msRequestFullscreen) {
            element.msRequestFullscreen();
          } else if (element.webkitRequestFullscreen) {
            element.webkitRequestFullScreen();
          }
        }
        launchFullscreen(document.documentElement); // 整个页面进入全屏
      }
    },
    command(e) {
      console.log(e);
      this.$router.push({ path: e });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.navigator {
  width: 100%;
  height: 88px;
  background: white;
  // border-bottom: 1px solid lightgrey;
  box-shadow: 0 2px 10px 0 rgba(0,0,0,.1);
  box-sizing: border-box;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
  .wrap {
    display: flex;
    height: 100%;
    justify-content: space-between;
    align-items: center;
    color: var(-theme-color);
    .logo-box {
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      img {
        height: 67px;
        margin-right: 23px;
      }
      span {
        font-size: 22px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #42aab2;
      }
    }
    .router-box {
      font-size: 0;
      line-height: 88px;
      span {
        font-size: 18px;
        font-family: PingFang SC;
        color: #7c7c7c;
        margin-left: 55px;
        cursor: pointer;
        transition: all 0.3s linear;
        position: relative;
      }
      span::after {
        position: absolute;
        bottom: -5px;
        width: 0;
        height: 4px;
        background-color: #42aab2;
        transform: translateX(-50%);
        left: 50%;
        content: " ";
        transition: all 0.3s linear;
      }
      span.active {
        color: #42aab2;
      }
      span.active::after {
        width: 47px;
      }
      span:first-child {
        margin-left: 0;
      }
    }
  }
}
@media (max-width: 760px) {
  .navigator {
    height: 1rem;
    padding: 0 0.25rem;
    width: 100vw;
    border-color: rgba(215, 215, 215, 0.5);
    position: fixed;
    .router-box {
      display: none;
    }
    .wrap {
      .logo-box {
        img {
          height: 90%;
          margin-right: 0.2rem;
        }
        span {
          font-size: 0.22rem;
        }
      }
      .el-icon-s-operation {
        font-size: 0.5rem;
        color: #42aab2;
      }
    }
  }
  .menu-li {
    text-align: center;
    display: block;
    width: 100%;
    color: #9a9a9a;
    font-size: 0.26rem;
  }
  .menu-li.active {
    color: #42aab2;
  }
}
/deep/ .el-dropdown-menu {
  background-color: rgba(255, 255, 255, 0.5);
}
</style>
